import { createEffect } from 'effector'
import Logger from '@services/logger'
import CommonAPI from '@api/external/common'
import { Entity } from '@loctypes'
import { WidgetConfig } from '@loctypes/widget-config'

type Arguments = { clientKey: string; entity: Entity }

export const fetchConfigFx = createEffect(
  ({ clientKey, entity }: Arguments): Promise<WidgetConfig> => {
    return CommonAPI.fetchConfig(clientKey, { type: entity })
  }
)

fetchConfigFx.fail.watch(({ error }) => {
  Logger('this "clientKey" is not valid or the request was broken. Check it out please!')
})
